import { Theme } from "theme-ui";

const theme: Theme = {
  breakpoints: ["40em", "52em", "64em"],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  colors: {
    blue: "#07c",
    bodyBackground: "#EFF0F5",
    primaryLight: "#f95b5a",
    headerFontColor: "#ffffff",
    lightgray: "#f6f6ff",
    primaryDark: "#797979",
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    body: "inherit",
    heading: "inherit",
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  shadows: {
    small: "0 0 4px rgba(0, 0, 0, .125)",
    large: "0 0 24px rgba(0, 0, 0, .125)",
  },
  text: {},
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
    },
  },
};

export default theme;
